import { render, staticRenderFns } from "./RegionTree.vue?vue&type=template&id=2f3e116b&scoped=true&"
import script from "./RegionTree.vue?vue&type=script&lang=js&"
export * from "./RegionTree.vue?vue&type=script&lang=js&"
import style0 from "./RegionTree.vue?vue&type=style&index=0&id=2f3e116b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e116b",
  null
  
)

export default component.exports